import { render } from "./HzbaMainView.vue?vue&type=template&id=1536b79a&ts=true"
import script from "./HzbaMainView.vue?vue&type=script&lang=ts"
export * from "./HzbaMainView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__